'use client'

import { WinningStatus, WinStatus } from "@/lib/enum/winStatus";
import { LotLiveData } from "@/app/api/auctions/[auctionId]/gridData/route";
import { Button } from "@/app/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/app/components/ui/tooltip";
import { formatCurrency } from "@/lib/utils";
import { AuctionState, Role } from "@prisma/client";
import { useAuctionTime } from "@/lib/context/AuctionTimeProvider";
import { useSession } from "next-auth/react";

const CatalogueBidButton = (
    { winningStatus, polledData, setIsOpen, auctionState }:
        { winningStatus: WinningStatus | undefined, polledData: LotLiveData, setIsOpen: (open: boolean) => void, auctionState: AuctionState }) => {
    const { data: session }: any = useSession();

    const { currentTime } = useAuctionTime();
    const timeLeft = (new Date(polledData.endDate)).getTime() - (new Date(currentTime)).getTime();
    let allowedToBid = allowCatalogueBid(winningStatus, auctionState, timeLeft) && session?.role !== Role.ADMIN;

    return !allowedToBid ? (
        <Tooltip delayDuration={200}>
            <TooltipTrigger asChild>
                <span className="cursor-pointer w-full">
                    <Button
                        className="uppercase w-full rounded-md text-[10pt]"
                        disabled={true}
                        onClick={() => setIsOpen(true)}
                    >
                        {polledData?.nextBid ? `BID ${formatCurrency(polledData.nextBid)}` : 'PLACE BID'}
                    </Button>
                </span>
            </TooltipTrigger>
            <TooltipContent>
                {getTooltipText(winningStatus, auctionState, polledData, session?.role)}
            </TooltipContent>
        </Tooltip>
    ) : (
        <Button
            className="uppercase w-full rounded-md text-[10pt]"
            onClick={() => {
                if (session?.role === Role.ADMIN) {
                    alert("Admin users cannot bid on lots.");
                } else {
                    setIsOpen(true);
                }
            }}
        >
            {polledData?.nextBid ? `BID ${formatCurrency(polledData.nextBid)}` : 'PLACE BID'}
        </Button>
    )
}

const biddableAuctionStates: AuctionState[] = [AuctionState.AUCTION, AuctionState.SOFT_CLOSING];

const allowCatalogueBid = (
    winningStatus: WinningStatus | undefined,
    auctionState: AuctionState,
    timeLeft: number,
) => {
    return timeLeft > 0 &&
        winningStatus?.winStatus !== WinStatus.WINNING &&
        biddableAuctionStates.includes(auctionState)
}

const getTooltipText = (
    winningStatus: WinningStatus | undefined,
    auctionState: AuctionState,
    polledData: LotLiveData,
    role: Role | undefined,
) => {
    if (role === Role.ADMIN) {
        return "Admin users cannot bid on lots.";
    }
    if (polledData.endDate && new Date(polledData.endDate).getTime() <= (new Date()).getTime()) {
        return "This lot is closed.";
    }
    if (!biddableAuctionStates.includes(auctionState)) {
        return "The auction is not currently accepting bids.";
    }
    if (winningStatus?.winStatus === WinStatus.WINNING) {
        return "You already have the highest bid on this lot.";
    }
    return ""
}

export default CatalogueBidButton;
